import styled from '@emotion/styled';
import { breakpointMedium, breakpointSmall } from '@/constants/breakpoints';
import { colors } from '@/constants/colors';

type TextWrapperProps = {
  margin?: string,
  padding?: string,
  center?: boolean,
  gap?: string,
};

export const TextWrapper = styled.div<TextWrapperProps>`
  display: flex;
  flex-direction: column;
  align-items: ${({ center }) => center && 'center'};
  padding: ${({ padding }) => padding};
  margin: ${({ margin }) => margin};
  gap: ${({ gap }) => gap};
`;

export const InnerTitle = styled.span`
padding: 5px 0;
font-size: 18px;
font-weight: 700;

@media (max-width: ${breakpointSmall}) {
  font-size: 14px;
}
`;

export const InnerContent = styled.span`
padding: 5px 0;
color: ${colors.arsenic};
font-size: 18px;
word-break: keep-all;

@media (max-width: ${breakpointSmall}) {
  font-size: 15px;
}
`;

export const SubTitle = styled.span`
margin-top: 8px;
font-size: 15px;
font-weight: 500;

@media (max-width: ${breakpointMedium}) {
  font-size: 13px;
  font-weight: 400;
}
`;
